import { Injectable,signal } from '@angular/core';
import { ScopeVariables } from '../Models/scopeVariables.model';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {
private _state = signal<ScopeVariables>({
  bLoggedIn: false,
  bSignInView: false,
  bSearchResults: false,
  bJobDetailsShown: false,
  bSidebarVisible: false,
  bSidebarShown: false,
  bSidebarOverlay: false,
  bPowerSearchVisible: false,
  bJobCart: false,
  bSelectedGroup: false,
  bJobCartLaunchedFromSearchResults: false,
  bJobCartLaunchedFromHome: false,
  bGQLaunchedFromJobCart: false,
  bCreateAccount: false,
  bCandidateZone: false,
  candidatezoneSubView: '',
  bEditProfileEditMode: false,
  candidatezoneEditProfileView: '',
  savedSearchActionCompletion: 0,
  searchResultsFromSavedSearch: null,
  subViewInitialized: false,
  bInitialLoad: false,
  notificationShow: false,
  commHistStartIndex: 1,
  commHistShowMore: false,
  communication: []
});
// Components can read but cannot directly overwrite
state = this._state.asReadonly();

// Method to update state properties
updateVariable<K extends keyof ScopeVariables>(key: K, value: ScopeVariables[K]) {
  this._state.update(state => ({
    ...state,
    [key]: value
  }));
}


}
